import { assetUrl } from '../../utils/assetPath';

export default function(url) {
  return assetUrl() + url;
}
